// ================================product-details===========
let productDetails = document.querySelector(".block_product-details");
productDetails.addEventListener("click", (event) => {
	let target = event.target;
   document.querySelector("body").classList.add("over-hidden");
	document.querySelector(".block_detail-popup").classList.toggle("hidden");
	document.querySelector(".block_detail-popup").classList.add("open"); 
})


// loveit

if(document.querySelectorAll(".block_product-lovit-title").length > 0){
  let productloveit = document.querySelector(".block_product-lovit-title");

productloveit.addEventListener("click", (event) => {
	let target = event.target;
	target.closest(".block_product-lovit").querySelector(".block_product-lovit-inner").classList.toggle("hidden");
	target.closest(".block_product-lovit").classList.toggle("active_product-lovit")
})
}




// ================overview============

if(document.querySelectorAll(".block_product-campaign").length > 0){
let showmoreText = document.querySelector(".block_product-campaign");

showmoreText.addEventListener("click", (event) => {
	let target = event.target;
	target.classList.toggle("active")
})
}

// ========open-box=====
 function openBox(event) {
   	document.querySelector(".block_open-box-popup").classList.toggle("hidden");
    document.querySelector("body").classList.add("over-hidden-open");
     var swiper = new Swiper(".block_oprn-box-popup-slider", {
       spaceBetween: 30,
        autoHeight: false,
       pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }
    });
 }

document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout( () =>  {
    if(document.querySelectorAll(".junip-product-review.junip-product-review-empty").length > 0){
      document.querySelector(".junip-product-review.junip-product-review-empty").closest(".block_product-reviews").remove(); 
    }   
  } , 2000)
})


